<script setup>

import TagComponent from "@/components/TagComponent.vue";
import { useMiscStore } from "@/stores/misc";
import LikeButtonComponent from "../LikeButtonComponent.vue";
import CommentCountComponent from "@/components/shared/CommentCountComponent.vue";
import {BuildingOfficeIcon, MapPinIcon} from "@heroicons/vue/16/solid";

const misc = useMiscStore(),
 props = defineProps({
  businesses: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    default: "all",
  }
}),
setCurrentSectorAndCategory = (sector, category) => {
  misc.setCurrentSector(sector);
  misc.setCurrentCategory(category);
};
</script>

<template>
  <ul class="">
    <li
      v-for="(business, index) in props.businesses"
      :key="business.id"
      :class="['flex flex-wrap px-0 justify-between items-center mb-4', index === 0 ? 'mt-4' : '']"
    >
      <div :class="['grid grid-cols-6']">
        <div :class="['col-span-4 text-left rounded-xl pb-4 pt-2 bg-white mr-2']">
          <h4 class="overflow-hidden whitespace-nowrap overflow-ellipsis">
            <router-link
              :to="`/${business.sector.name.toLowerCase()}/${business.category.name.toLowerCase()}/${
                business.id
              }`"
              target="_self"
              class="font-medium drop-shadow-sm text-gray-600 text-left w-full px-4 h5 text-[14.5px] hover:text-red-600 transition-all duration-700"
              @click="
                setCurrentSectorAndCategory(business.sector, business.category)
              "
            >
              {{ business.name }}
            </router-link>
          </h4>
          <div
            class="text-xs px-4 mt-2.5 mb-4"
          >
            <div class="flex items-center justify-start">
              <BuildingOfficeIcon
                id="bookmark"
                data-toggle="tooltip"
                class="h-4 w-4 text-left text-yellow-300 cursor-pointer -ml-1 mr-1 inline"
                aria-hidden="true"
                style="cursor:pointer;"
              />
              <span class="text-gray-400">
                {{ business?.region?.name || 'N/A' }}/{{ business?.city?.name || 'N/A' }}
              </span>
            </div>
            <div class="flex items-center justify-start mt-1">
              <MapPinIcon
                id="bookmark"
                data-toggle="tooltip"
                class="h-4 w-4 text-left text-green-300 cursor-pointer -ml-1 mr-1 inline"
                aria-hidden="true"
                style="cursor:pointer;"
              />
              <span class="text-gray-400 overflow-hidden whitespace-nowrap overflow-ellipsis ">
                {{ business?.address }}
              </span>
            </div>
          </div>
          <div class="text-xs mt-2 px-4 flex justify-between items-center w-full">
            <div class="items-center flex flex-grow no-more">
              <LikeButtonComponent
                :id="business.id"
                :count="business.likeCount"
                :user-has-liked="business.liked"
                size="h-4 w-4"
                :from="props.type"
              />
              <CommentCountComponent
                :id="business.id"
                :count="business.reviewCount"
                :user-has-reviewed="business.reviewed"
                :from="props.type"
              />
            </div>
            <span class="text-gray-500 flex justify-between items-center">
              <!--            <span class="ml-2 text-xs">-->
              <!--              12 year ago-->
              <!--            </span>-->
              <router-link
                :to="{
                  name: 'Category',
                  params: {
                    sector: business.sector.slug,
                    category: business.category.slug
                  }
                }"
                class="tag self-center text-xs"
                @click="setCurrentSectorAndCategory(business.sector, business.category)"
              >
                <TagComponent
                  :title="business.category.name"
                  :bg-color="business.category.background"
                  :color="business.category.color"
                  :class="`text-[.67rem] md:mt-2 rounded-md px-1.5 py-[2px]`"
                />
              </router-link>
            </span>
          </div>
        </div>

        <div class="col-span-2">
          <img
            :src="business.baseImageUrl"
            :alt="business.name"
            :class="['object-cover object-center w-full h-full rounded-xl']"
          >
        </div>
      </div>
    </li>
  </ul>
</template>

<style scoped>

</style>
